<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">商品列表</span>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                    type="selection"
                    header-align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="id"
                    header-align="center"
                    min-width="50"
                    label="商品ID">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="80"
                    label="商品图片">
                    <template scope="scope">
                      <div >
                        <img :src="scope.row.commodityIcon" alt="" style="width:50px;vertical-align:middle;margin:10px;">
                      </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="commodityName"
                    header-align="center"
                    min-width="100"
                    label="商品名称">

                </el-table-column>
                <el-table-column
                    prop="goodsUnit"
                    header-align="center"
                    min-width="100"
                    label="商品单位">
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    min-width="60"
                    label="商品状态">
                     <template slot-scope="scope">
                      <span>{{scope.row.commodityOnsale==0?'下架':'上架'}}</span>
                     </template>
                </el-table-column>
                <el-table-column
                    prop="commodityPrice"
                    header-align="center"
                    min-width="50"
                    label="商品价格">
                </el-table-column>
               
                <el-table-column
                    prop="warningCount"
                    header-align="center"
                    min-width="50"
                    label="告警数量">
                </el-table-column>

                <el-table-column
                    prop="ownerName"
                    header-align="center"
                    min-width="50"
                    label="所属用户">
                </el-table-column>

                <el-table-column
                  prop="userSetting"
                  header-align="center"
                  min-width="80"
                  label="操作">
                  <template scope="scope">
                   <el-button type="text" size="small"
            @click="lookAcc(scope.row.id)">编辑</el-button>
            <el-button
              @click="popUpdateDeviceCargoLane(scope.row.id, 0)"
              type="text" size="small" v-if="scope.row.commodityOnsale">下架</el-button>
              <el-button
              @click="popUpdateDeviceCargoLane(scope.row.id, 1)"
              type="text" size="small" v-else>上架</el-button>
              
                  </template>
                </el-table-column>
            </el-table>
        </div>

      </el-card>
      <po-add-pic :add-show="addPicShow" :cur-type="curType" @closeAddAccount="closeAddPic"></po-add-pic>
    </div>
</template>

<script>
import $axios from '../../https/config'
import poNewAddPic from '@/page/adMgr/adNewAddResourse'
import puSeePopRight from '@/page/fxshop/fxPopRight'

export default {
  data () {
    return {
      pageSize: 10000,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      pageTotal: 0,
      addPicShow: false,
      curType: 0,
      multipleSelection: ''
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryCommodityList()
  },
  methods: {
    convertCommodity2MutiGoods (commodity) {
      var mutiGoods = commodity;
      mutiGoods.goodsName = commodity.commodityName;
      mutiGoods.goodsIcon = commodity.commodityIcon;
      mutiGoods.goodsPrice = commodity.commodityPrice;
      return mutiGoods;
    },
    convertMutiGoods2Commodity (mutiGoods) {
      var commodity = mutiGoods;
      commodity.commodityName = commodity.goodsName;
      commodity.commodityIcon = commodity.goodsIcon;
      commodity.commodityPrice = commodity.goodsPrice;
      return commodity;
    },
    queryCommodityList () {

      var _this = this


      var userInfoStr = sessionStorage.getItem('lbz-device-user-info')
      var userInfo =  JSON.parse(userInfoStr)

      var params = {
        owner :userInfo.owner,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keys:"",
        sort:""
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/mutigoods/list', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            /*for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                id: itemData.id,
                commodityName: itemData.goodsName,
                commodityPrice: (itemData.goodsPrice / 100).toFixed(2),
                goodsUnit: itemData.goodsUnit,
                
                //当前商品状态
                commodityOnsale: itemData.commodityOnsale,
                commodityIcon: itemData.goodsIcon,
                
                
              }
              resData.push(item)
            }*/
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              itemData.goodsPrice = itemData.goodsPrice/100
              itemData = _this.convertMutiGoods2Commodity(itemData)

              console.log(JSON.stringify(itemData))
              resData.push(itemData)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    popUpdateDeviceCargoLane (id,status) {
            var that = this
            var params = {
              id: id,
              commodityOnsale: status
            }
            that.$confirm('是否上架/下架商品？', '确认切换', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              $axios.post('/mutiGoods/updateStatus', params, 'headers', function (res) {
                if (res && res.resultStatus === true) {
                  that.queryCommodityList ()
                  that.$message({
                    type: 'success',
                    message: '上下架商品成功!'
                  })
                  that.queryDeviceList()
                } else {
                  that.$message({
                    type: 'error',
                    message: '上下架商品失败!'
                  })
                }
              })
            }).catch(() => {
              that.$message({
                type: 'info',
                message: '已取消'
              })
          })
        },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList()
    },
    lookAcc (id) {
        window.open('/#/mutiGoods/mutiGoodsAdd?commodityId=' + id)
    },
    popNewAddPic (row) {
      this.addPicShow = true
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList()
    },
    handleSelectionChange (selection) {
      this.multipleSelection = ''
      for (var i = 0; i < selection.length; i++) {
        this.multipleSelection += (selection[i].code + '|')
      }
    },
    closeAddPic () {
      this.addPicShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    popRemovePic () {
      var that = this
      if (that.multipleSelection.length === 0) {
        that.$message({
          message: '请选择要回收的资源',
          type: 'info'
        })
        return false
      }
      var params = {
        adIds: that.multipleSelection
      }
      that.$confirm('您已选择广告的ID：' + that.multipleSelection, '是否删除选中的广告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/device/delAdResources', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.queryDeviceList()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
          }
        }, function () {
          that.$message({
            type: 'error',
            message: '删除失败!'
          })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  components: {
    'po-add-pic': poNewAddPic,
    'pu-see-pop-right': puSeePopRight
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/page/mutiGoods/mutiGoodsList.vue